import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  addressAndPaymentDefaultsLabel: {
    id: 'searchCustomerInfo.addressAndPaymentDefaultsLabel',
    defaultMessage: 'Osoite- ja maksuhäiriöt',
  },
  creditDecisionLabel: {
    id: 'searchCustomerInfo.creditDecisionLabel',
    defaultMessage: 'Rahoituspäätös',
  },
  confirmationHeader: {
    id: 'searchCustomerInfo.confirmationHeader',
    defaultMessage: 'Asiakkaan tietojen tarkastus',
  },
  firstNameLabel: {
    id: 'searchCustomerInfo.firstNameLabel',
    defaultMessage: 'Etunimi',
  },
  lastNameLabel: {
    id: 'searchCustomerInfo.lastNameLabel',
    defaultMessage: 'Sukunimi',
  },
  consentLabel: {
    id: 'searchCustomerInfo.consentLabel',
    defaultMessage: 'Olen tarkastanut asiakkaan henkilöllisyyden',
  },
  searchLabel: {
    id: 'searchCustomerInfo.searchLabel',
    defaultMessage: 'Hae',
  },
  cancelLabel: {
    id: 'searchCustomerInfo.cancelLabel',
    defaultMessage: 'Peruuta',
  },
})
